import { apiPaths, baseApi } from '@services';
import {
    APICustomFieldDescription,
    GetCfdAPIArgs,
    GetCfdAPIResponse,
} from '../types';

import { transformAPICustomFieldDescription } from '../utils/mappers';

export const facetingApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        //~ Simple query endpoint
        getCustomFieldDescriptions: builder.query<
            APICustomFieldDescription[],
            GetCfdAPIArgs
        >({
            query: ({ productionId }) => ({
                url: apiPaths.customFieldDescription.annotation(productionId),
            }),
            transformResponse: (response: GetCfdAPIResponse, meta, arg) =>
                transformAPICustomFieldDescription(response.fields, meta, arg),
        }),
    }),
});

export const {
    useGetCustomFieldDescriptionsQuery,
    useLazyGetCustomFieldDescriptionsQuery,
} = facetingApi;

export default facetingApi.endpoints;
